export default __webpack_public_path__ + "static/media/canada-vpj.94af7712.jpg";